import List from "@mui/material/List";
import ServiceListItem from "./components/ServiceListItem";
import styled from "@emotion/styled";
import {observer} from "mobx-react";

export type ConnectedServiceListProps = {
  onConnect?: (service: string) => void;
  onDisconnect?: (service: string) => void;
  services?: string[];
  isLoading?: boolean;
};

export default observer((props: ConnectedServiceListProps) => {
  const isConnected = (service: string): boolean => {
    return props.services ? props.services?.includes(service) : false;
  }

  return (
    <>
      <STitle>
        Подключите аккаунты спортивных приложений для автоматической
        синхронизации Ваших тренировок с YNA
      </STitle>
      <List>
        <ServiceListItem
          isLoading={props.isLoading}
          onConnect={props.onConnect}
          onDisconnect={props.onDisconnect}
          connected={isConnected("Garmin")}
          service={"Garmin"}
        />
        <ServiceListItem
          isLoading={props.isLoading}
          onConnect={props.onConnect}
          onDisconnect={props.onDisconnect}
          connected={isConnected("Strava")}
          service={"Strava"}
        />
      </List>
    </>
  );
});

const STitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #1a222d;
  padding-bottom: 44px;
`;
